import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { createNumberFormatters, resolveLocale, type NumberFormatters } from './numberFormat';

/**
 * Returns number formatters bound to the currently selected language.
 * Callers never pass a locale; it is resolved internally (English fallback).
 * The returned formatters re-create when the language changes, so values
 * re-format on language switch without a reload.
 */
export const useNumberFormat = (): NumberFormatters => {
  const {
    i18n: { language },
  } = useTranslation();
  const locale = resolveLocale(language);
  return useMemo(() => createNumberFormatters(locale), [locale]);
};
